import { Alert } from "@jugl-web/ui-components";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import { HELP_CENTER_URL } from "@jugl-web/utils/consts";
import workspaceLimitationAnimation from "./assets/workspace-limitation.json";

export const EntityLimitReachedAlert = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  return (
    <Alert
      isOpen={isOpen}
      onRequestClose={onClose}
      img={
        <Lottie
          options={{ animationData: workspaceLimitationAnimation }}
          height={150}
          width={150}
        />
      }
      title="You reached Workspace Limit"
      content="Oh no! Seems like You already created 5 of 5 free Personal Workspaces. You can update your plan to go unlimited ✨"
      buttons={[
        {
          text: "Cancel",
          color: "grey",
          role: "close",
        },
        {
          text: "Get More",
          onClick: () => {
            window.open(`${HELP_CENTER_URL}/en`, "_blank");
            onClose();
          },
        },
      ]}
    />
  );
};
